import * as React from "react";
const SvgCheckPricing = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: "17px", viewBox: "0 0 25 25", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m20.875 6.92603-11 10.99997-5-5", stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: 2.5 }));
export default SvgCheckPricing;
